var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "information-message-box" },
    [
      _c("MessageBoxCommon", {
        attrs: {
          showMessageBox: _vm.isSetShowMessageBox,
          title: _vm.$t(
            "home.walletConnect.acceptInvitationInformationMessageBox.title"
          ),
        },
        on: {
          "update:showMessageBox": function ($event) {
            _vm.isSetShowMessageBox = $event
          },
          "update:show-message-box": function ($event) {
            _vm.isSetShowMessageBox = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function () {
              return [
                _c("TradeCountdown", { on: { close: _vm.close } }),
                _c("div", { staticClass: "box-loading flex-center" }, [
                  _c("i", { staticClass: "icon icon-loading roll" }),
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "home.walletConnect.acceptInvitationInformationMessageBox.pleaseText"
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "box-message-content" }, [
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "home.walletConnect.acceptInvitationInformationMessageBox.youshouldText"
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c("p", { staticClass: "text-max text-invite-address" }, [
                    _vm._v(_vm._s(_vm.inviteAddress)),
                  ]),
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "home.walletConnect.acceptInvitationInformationMessageBox.followText"
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }